/* ==========================================================================
   Toalla Exfoliante de Ducha XELAE, module « avis clients ».

   Il porte la section 21 de la source : la liste des 75 avis, sa pagination,
   son tri, et le formulaire d'ajout d'avis. Il est separe du script principal
   parce qu'un seul fichier de 34 Ko ne passait pas le transfert de theme,
   alors que deux fichiers de 24 et 10 Ko passent.

   Les donnees des avis arrivent par assets/toalla-exfoliante-avis-data.js
   (window.TOA_AVIS_B64), en base64 : le JSON brut arrivait tronque sur les
   emojis des reponses de la marque.
   ========================================================================== */
(function () {
  'use strict';

  function echappe(t) {
    return String(t == null ? '' : t)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function each(selector, fn, root) {
    var nodes = (root || document).querySelectorAll(selector);
    for (var i = 0; i < nodes.length; i++) fn(nodes[i], i);
  }

  /* ---------- liste d'avis paginee (section 21 de la source) ---------- */

  var ETOILE_PLEINE =
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="#F5A623" d="m12 1.8 3.1 6.3 7 1-5 4.9 1.2 6.9-6.3-3.3-6.2 3.3 1.2-6.9-5.1-4.9 7-1z"/></svg>';
  var ETOILE_VIDE =
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="#dcdcdc" d="m12 1.8 3.1 6.3 7 1-5 4.9 1.2 6.9-6.3-3.3-6.2 3.3 1.2-6.9-5.1-4.9 7-1z"/></svg>';
  var ETOILE_DEMI =
    '<svg viewBox="0 0 24 24" aria-hidden="true"><defs><linearGradient id="toa-demi"><stop offset="50%" stop-color="#F5A623"/><stop offset="50%" stop-color="#dcdcdc"/></linearGradient></defs>' +
    '<path fill="url(#toa-demi)" d="m12 1.8 3.1 6.3 7 1-5 4.9 1.2 6.9-6.3-3.3-6.2 3.3 1.2-6.9-5.1-4.9 7-1z"/></svg>';
  var ICONE_VERIFIE =
    '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M21.007 8.27C22.194 9.125 23 10.45 23 12c0 1.55-.806 2.876-1.993 3.73.24 1.442-.134 2.958-1.227 4.05-1.095 1.095-2.61 1.459-4.046 1.225C14.883 22.196 13.546 23 12 23c-1.55 0-2.878-.807-3.731-1.996-1.438.235-2.954-.128-4.05-1.224-1.095-1.095-1.459-2.611-1.217-4.05C1.816 14.877 1 13.551 1 12s.816-2.878 2.002-3.73c-.242-1.439.122-2.955 1.218-4.05 1.093-1.094 2.61-1.467 4.057-1.227C9.125 1.804 10.453 1 12 1c1.545 0 2.88.803 3.732 1.993 1.442-.24 2.956.135 4.048 1.227 1.093 1.092 1.468 2.608 1.227 4.05Zm-4.426-.084a1 1 0 0 1 .233 1.395l-5 7a1 1 0 0 1-1.521.126l-3-3a1 1 0 0 1 1.414-1.414l2.165 2.165 4.314-6.04a1 1 0 0 1 1.395-.232Z" fill="#1c9cef"/></svg>';

  function etoiles(note, taille) {
    var out = '';
    for (var i = 1; i <= 5; i++) {
      if (note >= i) out += ETOILE_PLEINE;
      else if (note >= i - 0.5) out += ETOILE_DEMI;
      else out += ETOILE_VIDE;
    }
    return out;
  }

  function bindOpiniones() {
    var liste = document.querySelector('[data-toa-op-list]');
    if (!liste) return;
    /* Les avis voyagent en base64 : le JSON brut arrivait tronque sur les
       emojis lors du transfert du fichier de section. */
    var brut = window.TOA_AVIS_B64 || '';
    var conf = document.querySelector('[data-toa-op-config]');
    var avis, cfg;
    try {
      var bin = atob(String(brut).trim());
      var octets = new Uint8Array(bin.length);
      for (var b = 0; b < bin.length; b++) octets[b] = bin.charCodeAt(b);
      avis = JSON.parse(new TextDecoder('utf-8').decode(octets));
    } catch (e) { return; }
    try { cfg = JSON.parse(conf.textContent); } catch (e) { cfg = {}; }

    /* Avis deposes par le visiteur : ils rejoignent la liste en tete, comme sur
       la source, et survivent au rechargement. */
    var CLE = 'toa-op-mios';
    var miens = [];
    try { miens = JSON.parse(localStorage.getItem(CLE) || '[]'); } catch (e) { miens = []; }

    var pages = document.querySelector('[data-toa-op-pages]');
    var parPage = parseInt(cfg.porPagina, 10) || 15;
    var tri = 'destacadas';
    var page = 1;

    function corpus() {
      var tous = miens.concat(avis);
      var copie = tous.slice();
      if (tri === 'mejor') copie.sort(function (a, b) { return (b.e || 0) - (a.e || 0); });
      else if (tri === 'peor') copie.sort(function (a, b) { return (a.e || 0) - (b.e || 0); });
      else if (tri === 'recientes') copie.reverse();
      return copie;
    }

    function itemHTML(r) {
      var reply = '';
      if (r.r) {
        reply =
          '<div class="toa-op-item__reply">' +
            '<div class="toa-op-item__reply-head">' +
              (cfg.avatar ? '<img src="' + echappe(cfg.avatar) + '" alt="' + echappe(cfg.marca || '') +
                            '" width="44" height="44" loading="lazy">' : '') +
              '<span class="toa-op-item__reply-name">' + echappe(cfg.marca || '') + '</span>' +
            '</div>' +
            '<p class="toa-op-item__reply-body">' + echappe(r.r) + '</p>' +
          '</div>';
      }
      return '' +
        '<article class="toa-op-item">' +
          '<div class="toa-op-item__stars">' + etoiles(r.e || 5) + '</div>' +
          '<p class="toa-op-item__name">' + echappe(r.n) + '</p>' +
          (r.mio ? '' :
            '<div class="toa-op-item__verified">' + ICONE_VERIFIE +
            '<span>' + echappe(cfg.verificado || '') + '</span></div>') +
          '<p class="toa-op-item__text">' + echappe(r.t) + '</p>' +
          reply +
        '</article>';
    }

    /* Repli de la liste : la section faisait 5 385 px de haut, on n'en montre
       plus que `visibles` avis, le reste se deplie a la demande. Changer de
       page replie a nouveau. */
    var visibles = parseInt(cfg.visibles, 10) || 3;
    var plus = document.querySelector('[data-toa-op-more]');
    var deplie = false;

    function majRepli(nb) {
      var trop = nb > visibles;
      liste.classList.toggle('is-replie', trop && !deplie);
      if (!plus) return;
      plus.hidden = !trop;
      plus.setAttribute('aria-expanded', deplie ? 'true' : 'false');
      plus.textContent = deplie
        ? (cfg.moins || 'Ver menos')
        : (cfg.plus || 'Ver más opiniones');
    }

    if (plus) {
      plus.addEventListener('click', function () {
        deplie = !deplie;
        var n = liste.querySelectorAll('.toa-op-item').length;
        majRepli(n);
        if (!deplie) liste.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    function rendre() {
      var tous = corpus();
      var total = Math.max(1, Math.ceil(tous.length / parPage));
      if (page > total) page = total;
      var debut = (page - 1) * parPage;
      var tranche = tous.slice(debut, debut + parPage);
      liste.innerHTML = tranche.length
        ? tranche.map(itemHTML).join('')
        : '<p class="toa-op-item__text">' + echappe(cfg.vacio || '') + '</p>';
      majRepli(tranche.length);

      var html = '';
      html += '<li><button type="button" data-toa-op-page="' + (page - 1) + '"' +
              (page === 1 ? ' disabled' : '') + ' aria-label="&#8592;">&#8592;</button></li>';
      for (var p = 1; p <= total; p++) {
        html += '<li><button type="button" data-toa-op-page="' + p + '"' +
                (p === page ? ' aria-current="true"' : '') + '>' + p + '</button></li>';
      }
      html += '<li><button type="button" data-toa-op-page="' + (page + 1) + '"' +
              (page === total ? ' disabled' : '') + ' aria-label="&#8594;">&#8594;</button></li>';
      pages.innerHTML = html;

      each('[data-toa-op-page]', function (b) {
        b.addEventListener('click', function () {
          var n = parseInt(b.getAttribute('data-toa-op-page'), 10);
          if (n < 1 || n > total) return;
          page = n;
          deplie = false;
          rendre();
          liste.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }, pages);
    }

    /* etoiles de l'en-tete */
    each('[data-toa-op-stars]', function (el) {
      el.innerHTML = etoiles(parseFloat(el.getAttribute('data-toa-op-stars')) || 0);
    });

    /* tri */
    var popup = document.querySelector('[data-toa-op-sort-popup]');
    var btnTri = document.querySelector('[data-toa-op-sort-btn]');
    if (btnTri && popup) {
      btnTri.addEventListener('click', function () {
        var ouvert = !popup.hidden;
        popup.hidden = ouvert;
        btnTri.setAttribute('aria-expanded', ouvert ? 'false' : 'true');
      });
      document.addEventListener('click', function (e) {
        if (!popup.hidden && !e.target.closest('.toa-op__sort')) {
          popup.hidden = true;
          btnTri.setAttribute('aria-expanded', 'false');
        }
      });
      each('[data-toa-op-sort]', function (b) {
        b.addEventListener('click', function () {
          tri = b.getAttribute('data-toa-op-sort');
          each('[data-toa-op-sort]', function (o) { o.classList.toggle('is-active', o === b); });
          popup.hidden = true;
          btnTri.setAttribute('aria-expanded', 'false');
          page = 1;
          rendre();
        });
      }, popup);
    }

    /* formulaire d'avis */
    var form = document.querySelector('[data-toa-op-form]');
    var ouvre = document.querySelector('[data-toa-op-write]');
    var annule = document.querySelector('[data-toa-op-cancel]');
    var noteForm = 5;
    var zoneEtoiles = document.querySelector('[data-toa-op-form-stars]');
    if (zoneEtoiles) {
      function peindre() {
        var h = '';
        for (var i = 1; i <= 5; i++) {
          h += '<button type="button" data-toa-op-note="' + i + '" role="radio" aria-checked="' +
               (i === noteForm ? 'true' : 'false') + '" aria-label="' + i + '">' +
               (i <= noteForm ? ETOILE_PLEINE : ETOILE_VIDE) + '</button>';
        }
        zoneEtoiles.innerHTML = h;
        each('[data-toa-op-note]', function (b) {
          b.addEventListener('click', function () {
            noteForm = parseInt(b.getAttribute('data-toa-op-note'), 10);
            peindre();
          });
        }, zoneEtoiles);
      }
      peindre();
    }
    if (ouvre && form) {
      ouvre.addEventListener('click', function () {
        form.hidden = !form.hidden;
        if (!form.hidden) form.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
    if (annule && form) annule.addEventListener('click', function () { form.hidden = true; });
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var nom = form.querySelector('[name="nombre"]').value.trim();
        var txt = form.querySelector('[name="texto"]').value.trim();
        if (!nom || !txt) return;
        miens.unshift({ n: nom, t: txt, e: noteForm, mio: true });
        try { localStorage.setItem(CLE, JSON.stringify(miens)); } catch (err) {}
        form.reset();
        noteForm = 5;
        var note = document.querySelector('[data-toa-op-form-note]');
        if (note) note.hidden = false;
        page = 1;
        tri = 'destacadas';
        rendre();
      });
    }

    /* Le formulaire de la section « Descubre por que » ecrit dans le MEME
       magasin : un seul endroit ou les avis du visiteur atterrissent (§31.7). */
    var envoi = document.querySelector('[data-toa-avis-envoyer]');
    if (envoi) {
      envoi.addEventListener('click', function () {
        var bloc = envoi.closest('[data-toa-avis-form]');
        if (!bloc) return;
        var nom = (bloc.querySelector('[name="toalla-exfoliante-avis-nom"]') || {}).value || '';
        var txt = (bloc.querySelector('[name="toalla-exfoliante-avis-texte"]') || {}).value || '';
        var note = parseInt((bloc.querySelector('[name="toalla-exfoliante-avis-note"]') || {}).value, 10) || 5;
        nom = nom.trim(); txt = txt.trim();
        if (!nom || !txt) return;
        miens.unshift({ n: nom, t: txt, e: note, mio: true });
        try { localStorage.setItem(CLE, JSON.stringify(miens)); } catch (err) {}
        bloc.querySelectorAll('input, textarea').forEach(function (c) { c.value = ''; });
        var sel = bloc.querySelector('select'); if (sel) sel.value = '';
        var merci = bloc.querySelector('[data-toa-avis-merci]');
        if (merci) merci.hidden = false;
        page = 1;
        rendre();
      });
    }

    rendre();
  }


  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindOpiniones);
  } else {
    bindOpiniones();
  }
})();
